var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('category-page',{attrs:{"category-list":_vm.categoryList,"route-name":"temps-home","title":"Temps de travail","icon":"mdi-timer"}})}
var staticRenderFns = []

export { render, staticRenderFns }